// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Switch--1KyTi"};